const lazyVideoHeroTag = 'vela-lazy-video-hero';

if (!customElements.get(lazyVideoHeroTag)) {
  class LazyVideoHero extends HTMLElement {
    connectedCallback() {
      this.video = this.querySelector('video');

      if (!this.video) return;

      this.handleIntersection = this.handleIntersection.bind(this);
      this.handlePlaying = this.handlePlaying.bind(this);
      this.handleVideoError = this.handleVideoError.bind(this);

      this.video.addEventListener('playing', this.handlePlaying);
      this.video.addEventListener('error', this.handleVideoError);

      if ('IntersectionObserver' in window) {
        this.observer = new IntersectionObserver(this.handleIntersection, {
          rootMargin: '250px 0px',
          threshold: 0.01,
        });
        this.observer.observe(this);
      } else {
        this.playVideo();
      }
    }

    disconnectedCallback() {
      this.observer?.disconnect();
      this.video?.pause();
      this.video?.removeEventListener('playing', this.handlePlaying);
      this.video?.removeEventListener('error', this.handleVideoError);
    }

    handleIntersection(entries) {
      for (const entry of entries) {
        if (entry.isIntersecting) {
          this.playVideo();
        } else if (this.video.dataset.loaded === 'true') {
          this.video.pause();
        }
      }
    }

    loadVideo() {
      if (this.video.dataset.loaded === 'true') return;

      const sources = this.video.querySelectorAll('source[data-src]');

      for (const source of sources) {
        source.src = source.dataset.src;
        source.removeAttribute('data-src');
      }

      this.video.dataset.loaded = 'true';
      this.video.load();
    }

    playVideo() {
      this.loadVideo();

      const playPromise = this.video.play();
      if (playPromise) playPromise.catch(() => {});
    }

    handlePlaying() {
      this.classList.add('is-playing');
    }

    handleVideoError() {
      this.classList.remove('is-playing');
    }
  }

  customElements.define(lazyVideoHeroTag, LazyVideoHero);
}
